var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricTower({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#fff;}.c{fill:#414952;}.d{filter:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.106,
    y1: 1.116,
    x2: 0,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faab45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f37321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 0,
    width: 67,
    height: 67,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.098
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 13)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -15, -13)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    transform: "translate(15 13)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.921 3.758)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M124.837,76.018l.338,2.233,2.144-.325-3.114-20.56L120.182,52l-4.023,5.362-.233,1.536h-4.7v4.284H113.4V61.07h2.2l-.98,6.471H109.6v4.284h2.168V69.708h2.52l-1.244,8.218,2.144.325.354-2.341,4.571-3.261Zm-2.856-4.7,1.935-1.381.469,3.1Zm.328-11.992.007.046-2.2,1.571-2.079-1.484.02-.133h4.254Zm.371,2.449.169,1.118-.868-.62Zm-4.432.5-.717.511.14-.923Zm1.866,1.332,3.187,2.274.014.092h-6.266l.03-.2Zm2.588,4.534-2.588,1.847-2.588-1.847Zm-1.364-10.981h-2.313l1.156-1.541ZM116,72.924l.439-2.9,1.813,1.294Z",
    transform: "translate(-109.603 -52.003)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M260.7,67.54l-.98-6.471h2.2v2.116h2.168V58.9h-4.7l-.233-1.536L255.132,52v3.613l1.156,1.541h-1.154v2.168h2.125l.007.046-2.2,1.571V63.6l3.187,2.274.014.092h-3.131v2.168h2.518l-2.588,1.847v2.663l4.722,3.37.338,2.232,2.144-.325-1.244-8.218h2.52v2.116h2.168V67.54Zm-3.765-5.267.7-.5.169,1.118Zm0,9.044,1.935-1.381.469,3.1Z",
    transform: "translate(-244.552 -52.003)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.497 25.379)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M144.15,403.193h16.166V406.3H144.15Z",
    transform: "translate(-144.15 -403.193)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.581 25.379)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M256.028,403.193h8.081V406.3h-8.081Z",
    transform: "translate(-256.028 -403.193)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricTower);
export default __webpack_public_path__ + "static/media/electric-tower.53c1f77c405cc104c7987f2e64f9e412.svg";
export { ForwardRef as ReactComponent };